import { render, staticRenderFns } from "./articlemodale.vue?vue&type=template&id=3984dc03&scoped=true"
import script from "./articlemodale.vue?vue&type=script&lang=js"
export * from "./articlemodale.vue?vue&type=script&lang=js"
import style0 from "./articlemodale.vue?vue&type=style&index=0&id=3984dc03&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3984dc03",
  null
  
)

export default component.exports